module.exports = {
  "country": "PL",
  "artist": "Ochmann",
  "song": "River",
  "year": "2022",
  "place": "12",
  "spotify": ""
};